exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attachment[data-v-fca98b0e]{height:46px;border-radius:5px}.pointer[data-v-fca98b0e]{cursor:pointer}", ""]);

// exports
